<template>
  <v-container class="welcome">
    <v-layout row>
      <v-flex xs12 sm4 offset-sm4>
        <v-container class="medium-div">
          <v-container class="without-padding container-img">
            <v-img :src="require('../../assets/logoPonce.png')"/>
          </v-container>
          <div v-if="!showTokenError">
            <p class="text-title">{{$t('Welcome.welcome')}}</p>
            <p class="text-description">{{$t('Welcome.description')}}</p>
            <v-form class="signup-form" @submit.prevent="onSignin" ref="welcomeForm">
              <v-layout row>
                <v-text-field class="input-email"
                  prepend-inner-icon="mail"
                  name="email"
                  :label="$t('Welcome.email')"
                  id="email"
                  v-model="email"
                  type="email"
                  color="#00202F"
                  :rules="$ponceConfig.emailRules"
                  maxlength="254"
                  validate-on-blur
                  :disabled="disableEmail"
                  required></v-text-field>
              </v-layout>
              <v-layout row>
                <v-text-field class="input-password"
                  prepend-inner-icon="lock"
                  :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  name="password"
                  :label="$t('Welcome.password')"
                  id="password"
                  v-model="password"
                  type="password"
                  color="#00202F"
                  :rules="$ponceConfig.passwordRules"
                  validate-on-blur
                  required
                  @click:append="showPassword = !showPassword"
                />
              </v-layout>
              <v-layout row>
              <v-text-field class="input-password"
                prepend-inner-icon="lock"
                :append-icon="!showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                name="passwordConfirmation"
                :label="$t('Welcome.passwordConfirmation')"
                id="password"
                v-model="passwordConfirmation"
                :type="showPasswordConfirmation ? 'text' : 'password'"
                color="#00202F"
                :rules="$ponceConfig.passwordRules"
                validate-on-blur
                required
                @click:append="showPasswordConfirmation = !showPasswordConfirmation"
              />
            </v-layout>
              <v-layout row style="padding-top:10px">
                <v-flex xs12>
                  <div class="text-center">
                    <v-btn class="submit-btn" block type="submit" :loading="loading">
                      {{$t('Welcome.confirm')}}
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </div>
          <div v-else class="text-center">
            <p class="text-title mb-4">{{$t('Welcome.tokenInvalid')}}</p>
            <v-btn
              @click="resendInvitationByToken"
              :loading="resendLoading"
              color="#0098E1"
              class="text-none text-h6"
              dark
            >
              {{$t('Welcome.resendInvitation')}}
              <v-icon right dark>forward_to_inbox</v-icon>
            </v-btn>
          </div>
          <div class="bottom-div">
            <p class="bottom-text">PONCE</p>
          </div>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {WEBHOOKS_PATHS, HTTP_STATUS, CUSTOM_ERROR_CODES} from '../../constants/const'
  import {auth} from '@/plugins/firebase'

  export default {
    data () {
      return {
        password: '',
        passwordConfirmation: '',
        email: '',
        disableEmail: false,
        loading: false,
        showTokenError: false,
        resendLoading: false,
        showPassword: false,
        showPasswordConfirmation: false
      }
    },
    async created () {
      await this.validateUserToken()
    },
    methods: {
      isTokenExpired (token) {
        try {
          const parts = token.split('.')
          if (parts.length !== 3) {
            return false
          }
          // Decode the payload (second part of JWT)
          const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
          
          // Check if exp field exists and if it's expired
          if (payload.exp) {
            const currentTime = Math.floor(Date.now() / 1000) // Current time in seconds
            return payload.exp < currentTime
          }
          return false
        } catch (error) {
          console.warn('Error decoding token:', error)
          return false
        }
      },
      redirectToDevicesApp (tokenExpired) {
        const tokenExpiredMsj = tokenExpired ? `?errorSnack=${CUSTOM_ERROR_CODES.TOKEN_EXPIRED}` : ''
        location.replace(`${process.env.DEVICES_APP_URL}/login${tokenExpiredMsj}`)
      },
      async onSignin () {
        if (this.$refs.welcomeForm.validate()) {
          if (this.password !== this.passwordConfirmation) {
            this.$root.snack.show({text: this.$t('Welcome.passwordsDoNotMatch'), error: true})
            return
          }
          this.loading = true
          try {
            const signInMethodsForEmail = await auth.fetchSignInMethodsForEmail(this.email)
            if (signInMethodsForEmail.length > 0) {
              this.$root.snack.show({text: this.$t('Config.emailAlreadyInUse'), error: true})
              return
            }
            const response = await fetch(`${process.env.WEBHOOKS_URL}${WEBHOOKS_PATHS.CREATE_USER}`, {
              method: 'POST',
              body: JSON.stringify({
                token: this.$route.params.createUserToken,
                email: this.email,
                password: this.password
              }),
              headers: {
                authorization: process.env.WEBHOOKS_BASIC_TOKEN,
                'Content-Type': 'application/json'
              }
            })

            if (response.status === HTTP_STATUS.OK) {
              const resData = await response.json()
              this.$root.snack.show({text: this.$t('Welcome.registerSuccess')})
              setTimeout(async () => {
                if (!resData.editDataPermission && !resData.auditPermission) {
                  this.redirectToDevicesApp()
                } else {
                  try {
                    const user = await auth.signInWithEmailAndPassword(this.email, this.password)
                    this.$store.dispatch('autoSignIn', user)
                    this.$router.push({name: 'LoadingScreen'})
                  } catch (error) {
                    this.$root.snack.show({text: this.$t('Welcome.loginError'), error: true})
                    this.$router.push({name: 'Signin'})
                  }
                }
              }, 3000)
            } else {
              throw new Error(`Error query status ${response.status}`)
            }
          } catch (error) {
            this.$root.snack.show({text: this.$t('UI.serverError'), error: true})
          } finally {
            this.loading = false
          }
        } else {
          this.$root.snack.show({text: this.$t('Config.fillRequiredFields'), error: true})
        }
      },
      async validateUserToken () {
        let isValid = false
        this.loading = true
        
        // Check if token is expired before making the API call
        const token = this.$route.params.createUserToken
        const isExpired = this.isTokenExpired(token)
        
        try {
          const response = await fetch(`${process.env.WEBHOOKS_URL}${WEBHOOKS_PATHS.VALIDATE_USER_TOKEN}`, {
            method: 'POST',
            body: JSON.stringify({token}),
            headers: {
              authorization: process.env.WEBHOOKS_BASIC_TOKEN,
              'Content-Type': 'application/json'
            }
          })
          if (response.status === HTTP_STATUS.OK) {
            const resData = await response.json()
            if (resData.isValid) {
              isValid = true
              if (resData.email) {
                this.email = resData.email
                this.disableEmail = true
              }
            }
          }
        } catch (error) {
          this.$root.snack.show({text: this.$t('UI.serverError'), error: true})
        } finally {
          this.loading = false
          if (!isValid) {
            if (isExpired) {
              // Show token expired error with resend option
              this.showTokenError = true
            } else {
              // Redirect to devices app for other invalid tokens
              this.redirectToDevicesApp()
            }
          }
        }
      },
      async resendInvitationByToken () {
        try {
          this.resendLoading = true
          let userId = null
          
          // Try to extract userId from JWT token
          try {
            const token = this.$route.params.createUserToken
            const parts = token.split('.')
            if (parts.length === 3) {
              // Decode the payload (second part of JWT)
              const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
              userId = payload.userId
            }
          } catch (e) {
            console.warn('Could not decode token to get userId:', e)
          }

          if (userId) {
            // Use the existing resendUserInvitation function if we have userId
            const { resendUserInvitation } = await import('../../lib/crudOperations/write')
            console.log('userId', userId)
            await resendUserInvitation(userId)
            this.$root.snack.show({text: this.$t('Welcome.invitationSent')})
          } else {
            console.error('Could not get userId from token')
          }
        } catch (error) {
          console.error('Error resending invitation:', error)
          this.$root.snack.show({text: this.$t('UI.serverError'), error: true})
        } finally {
          this.resendLoading = false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Welcome.vue?4cbf1eb4